/**
 * @file PaddleHub 首页应用场景
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useEffect, useMemo} from 'react';
import classNames from 'classnames';
import {IApplicationScenarios} from '../../types';
import useApplicationScenariosStore from './applicationScenariosHooks';

interface IApplicationScenariosProps extends IApplicationScenarios {
    selectedTabKey: string;
    setSelectedTabKey: (key: string) => any;
}

const ApplicationScenarios: React.FC<IApplicationScenariosProps> = props => {
    const {group} = props;

    const {
        selectedTabKey,
        isFirstLoad,
        setSelectedTabKey
    } = useApplicationScenariosStore();

    const showList = useMemo(() => {
        const findItem = group.find(item => item.title === selectedTabKey);
        if (findItem) {
            return findItem.list;
        }
        return [];
    }, [group, selectedTabKey]);

    useEffect(() => {
        if (isFirstLoad.current && !selectedTabKey && group.length > 0) {
            isFirstLoad.current = false;
            setSelectedTabKey(group[0].title);
        }
    }, [selectedTabKey, group, isFirstLoad, setSelectedTabKey]);

    return (
        <div className="paddle-hub-as clear-both">
            <div className="paddle-hub-as-menu">
                {group.map(tab => (
                    <div
                        key={tab.title}
                        className={classNames(
                            'paddle-hub-as-menu-item',
                            {'paddle-hub-as-menu-item-selected': tab.title === selectedTabKey}
                        )}
                        onClick={() => setSelectedTabKey(tab.title)}
                        onMouseEnter={() => setSelectedTabKey(tab.title)}
                    >
                        {tab.title}
                    </div>
                ))}
            </div>
            <div className="paddle-hub-as-menu-background" />
            <div className="paddle-hub-as-body">
                {showList.map(item => (
                    <div key={item.title} className="paddle-hub-as-item">
                        <div className="paddle-hub-as-item-img">
                            <img alt={item.title} src={item.imgUrl} />
                        </div>
                        <div className="paddle-hub-as-item-body">
                            <div className="paddle-hub-as-item-title">
                                {item.title}
                            </div>
                            <div className="paddle-hub-as-item-context">
                                <table className="paddle-hub-as-item-context-form">
                                    <tbody>
                                    <tr>
                                        <td className="paddle-hub-as-item-context-form-label">场景介绍</td>
                                        <td>{item.desc}</td>
                                    </tr>
                                    <tr>
                                        <td className="paddle-hub-as-item-context-form-label">数据集</td>
                                        <td>{item.dataSet}</td>
                                    </tr>
                                    <tr>
                                        <td className="paddle-hub-as-item-context-form-label">可用模型</td>
                                        <td>
                                            <div className="paddle-hub-as-item-context-form-model-list">
                                                {item.modelList.map(model => (
                                                    <a key={model.label} href={model.href}>{model.label}</a>
                                                ))}
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="paddle-hub-as-item-tags">
                                {item.btns.map(btn => (
                                    <a
                                        key={btn.label}
                                        className={classNames(
                                            'paddle-hub-as-item-tag',
                                            {'paddle-hub-as-item-tag-disabled': !btn.href}
                                        )}
                                        href={btn.href ? btn.href : undefined}
                                    >
                                        {btn.label}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ApplicationScenarios;
